import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";


export default function CrudTable({
  data,
  onEdit,
  onEditLink,
  onDelete,
  onToggleStatus,
  onToggleApprovedStatus,
    onTogglePrescription,
      selectedIds = [],
  onSelectOne,
  onSelectAll,
  columns,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  // SEARCH STATES
  const [searchText, setSearchText] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [openDropdownId, setOpenDropdownId] = useState(null);


  const handleSettingsClick = (id) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
  };

  const handleNavigateToGallery = (id) => {
    navigate(`/admin/product-image-gallery/${id}`);
  };

  const isProductGalleryPage = currentPath.startsWith(
    "/admin/product-image-gallery"
  );


  const handleNavigateToProductReview = (id) => {
    navigate(`/admin/product-review/${id}`);
  };

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltips = Array.from(tooltipTriggerList).map((el) => {
      if (!el._tooltip) {
        return new window.bootstrap.Tooltip(el);
      }
      return el._tooltip;
    });
    return () => {
      tooltips.forEach((tooltip) => tooltip.dispose());
    };
  }, [data]);


  const orderPages = [
    "/admin/all-orders",
    "/admin/new-orders",
    "/admin/delivered-orders",
    "/admin/cancelled-orders",
    "/admin/pending-orders",
  ];

  const isOrderPage = orderPages.includes(currentPath);

  const filteredData =
    data?.filter((row) => {
      const matchesSearch = Object.values(row)
        .filter(v => v !== null && v !== undefined)
        .join(" ")
        .toLowerCase()
        .includes(searchText.toLowerCase());

      if (!isOrderPage) return matchesSearch;

      if (!row.created_at) return false;

      const rowDate = new Date(row.created_at);
      rowDate.setHours(0, 0, 0, 0);

      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      if (start) start.setHours(0, 0, 0, 0);
      if (end) end.setHours(23, 59, 59, 999);

      const matchesStart = start ? rowDate >= start : true;
      const matchesEnd = end ? rowDate <= end : true;

      return matchesSearch && matchesStart && matchesEnd;
    }) || [];








  const columnWidths = {
    sl: "80px",
    status: "100px",
    approved_status: "140px",
    actions: "250px",
    order_status:"130px",
    payment_status:"150px",
    payment_method:"150px",
    product_qty:"130px",
    order_date:"130px",
    user_name:"130px"
  };


  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const dateRangeText =
    startDate && endDate
      ? `Order Date: ${formatDate(startDate)} - ${formatDate(endDate)}`
      : startDate
        ? `Order Date: From ${formatDate(startDate)}`
        : endDate
          ? `Order Date: Until ${formatDate(endDate)}`
          : "Order Date: All Dates";


  const generateFileName = () => {
    // Extract the last part of the route, e.g., "all-products"
    const pathSegments = currentPath.split("/").filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1] || "report";

    // Optional: add date range for orders
    let datePart = "";
    if (isOrderPage && (startDate || endDate)) {
      const start = startDate ? formatDate(startDate) : "";
      const end = endDate ? formatDate(endDate) : "";
      datePart = start && end ? `-${start}-to-${end}` : `-${start || end}`;
    }

    // Clean filename: replace spaces or commas with hyphens
    const safeName = `${lastSegment}${datePart}`
      .replace(/[^a-z0-9-]/gi, "-")
      .toLowerCase();

    return safeName;
  };



  // const downloadPDF = () => {
  //   const doc = new jsPDF();

  //   // Title
  //   doc.setFontSize(14);
  //   doc.text("Orders Report", 14, 15);

  //   // Date Range
  //   doc.setFontSize(10);
  //   doc.text(dateRangeText, 14, 22);

  //   autoTable(doc, {
  //     startY: 28,
  //     head: [columns.map(col => col.toUpperCase())],
  //     body: filteredData.map(item =>
  //       columns.map(col => item[col])
  //     ),
  //   });

  //   doc.save("orders-report.pdf");
  // };
  const downloadPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(14);
    doc.text("Report", 14, 15);

    doc.setFontSize(10);
    doc.text(dateRangeText, 14, 22);

    autoTable(doc, {
      startY: 28,
      head: [columns.map((col) => col.toUpperCase())],
      body: filteredData.map((item) => columns.map((col) => item[col])),
    });

    doc.save(`${generateFileName()}.pdf`);
  };




  // const downloadExcel = () => {
  //   const worksheetData = [
  //     [dateRangeText],
  //     [],
  //     columns.map(col => col.toUpperCase()),
  //     ...filteredData.map(item =>
  //       columns.map(col => item[col])
  //     ),
  //   ];

  //   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  //   XLSX.writeFile(workbook, "orders-report.xlsx");
  // };


  const downloadExcel = () => {
    const worksheetData = [
      [dateRangeText],
      [],
      columns.map((col) => col.toUpperCase()),
      ...filteredData.map((item) => columns.map((col) => item[col])),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, `${generateFileName()}.xlsx`);
  };

  useEffect(() => {
  const excelHandler = () => downloadExcel();
  const pdfHandler = () => downloadPDF();

  document.addEventListener("downloadExcel", excelHandler);
  document.addEventListener("downloadPDF", pdfHandler);

  return () => {
    document.removeEventListener("downloadExcel", excelHandler);
    document.removeEventListener("downloadPDF", pdfHandler);
  };
}, [filteredData]);
const hideCheckboxPages = [
  "/admin/all-orders",
  "/admin/new-orders",
  "/admin/delivered-orders",
  "/admin/cancelled-orders",
  "/admin/pending-orders",
  "/admin/transactions",
  "/admin/customer-management",
  "/admin/contact-us-list",
  "/admin/shipping-rule",
  "/admin/sliders",
  "/admin/brands",
  "/admin/home-section-products",
  "/admin/categories",
  "/admin/sub-categories",
  "/admin/child-categories",
  

];

const isProductImageGalleryPage =
  currentPath.startsWith("/admin/product-image-gallery/");

const shouldShowCheckboxes =
  !hideCheckboxPages.includes(currentPath) &&
  !isProductImageGalleryPage;

const selectColumn = {
  name: " ",
  cell: (row) => (
    <input
      type="checkbox"
      checked={selectedIds.includes(row.id)}
      onChange={() => onSelectOne(row.id)}
    />
  ),
  width: "70px",
  ignoreRowClick: true,
  allowOverflow: true,
};
// ADD THIS HERE
const formatColumnName = (col) => {
  return col
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
const tableColumns = [
  ...(shouldShowCheckboxes ? [selectColumn] : []),
  ...columns.map((col) => {
    const width = columnWidths[col];
if (col === "is_prescription") {
  return {
   name: "Prescription",
    cell: (row) => (
      <div className="form-check form-switch">
        <input
          type="checkbox"
          className="form-check-input"
          checked={!!row.is_prescription}
          onChange={() =>
            onTogglePrescription && onTogglePrescription(row)
          }
        />
      </div>
    ),
    sortable: true,
     width: "160px",  
    wrap: true,
  };
}
    if (col === "status") {
      return {
       name: "Status",
        cell: (row) => (
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.status}
              onChange={() => onToggleStatus && onToggleStatus(row)}
            />
          </div>
        ),
        sortable: true,
        width,
      };
    }

    // Toggle button for Customer Active Status
    if (col === "is_active") {
      return {
       name: "Is Active",
        cell: (row) => (
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.is_active}
              onChange={() => onToggleStatus && onToggleStatus(row)}
              aria-label={`Toggle active status for ${row.username || "customer"}`}
            />
          </div>
        ),
        sortable: true,
        width: "120px",
      };
    }


    if (col === "show_at_home") {
      return {
        name: "SHOW AT HOME",
        cell: (row) => (
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.show_at_home}
              onChange={() =>
                onToggleApprovedStatus && onToggleApprovedStatus(row)
              }
            />
          </div>
        ),
        sortable: true,
        width: "150px",
      };
    }

    if (col === "is_approved") {
      return {
       name: "Approval",
        cell: (row) => (
          <select
            className="form-select form-select-sm"
            value={row.is_approved ? "approved" : "pending"}
            onChange={(e) =>
              onToggleApprovedStatus &&
              onToggleApprovedStatus(row, e.target.value)
            }
            style={{ minWidth: "100px", fontSize: "12px" }}
          >
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
          </select>
        ),
        sortable: true,
         width: "160px",  
    wrap: true,
      };
    }

    if (col === "is_default") {
      return {
        name: "DEFAULT",
        cell: (row) => {
          const isDefault = row[col] === 1 || row[col] === true;

          return (
            <div
              style={{
                backgroundColor: isDefault ? "#D1FAE5" : "#FECACA",
                color: isDefault ? "#1e939b" : "#991B1B",
                padding: "4px 8px",
                borderRadius: "15px",
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {isDefault ? "Default" : "No"}
            </div>
          );
        },
        sortable: true,
        width,
      };
    }

    if (col === "is_featured") {
      return {
        name: "FEATURED",
        cell: (row) => {
          const isFeatured = row[col] === 1 || row[col] === true;
          return (
            <div
              style={{
                backgroundColor: isFeatured ? "#D1FAE5" : "#FECACA",
                color: isFeatured ? "#1e939b" : "#991B1B",
                padding: "6px 18px",
                borderRadius: "15px",
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {isFeatured ? "Yes" : "No"}
            </div>
          );
        },
        sortable: true,
        width,
      };
    }

    if (
      col === "logo" ||
      col === "banner" ||
      col === "blog_image" ||
      col === "brand_logo" || 
      col === "brand_image" ||
      col === "thumb_image" ||
      col === "cat_image" ||
      col === "sub_cat_image" ||
      col === "image"  
     
     
    ) {
      return {
        name: col
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
           width: "140px",
  wrap: true,
        cell: (row) =>
          row[col] ? (
            <img
              src={
                row[col].startsWith("http")
                  ? row[col]
                  : `${process.env.REACT_APP_BASE_IMAGE_URL}${row[col]}`
              }
              alt={col}
              style={{ width: "80px", height: "50px", objectFit: "contain" }}
            />
          ) : (
            "No Image"
          ),
        sortable: false,
      };
    }

  return {
  name:
    col === "order_date"
      ? "Order Date"
      : col === "product_type"
        ? "Product Type"
        : formatColumnName(col),
      cell: (row) => {
        let value = row[col];

        if (col === "product_type") {
          if (!value || typeof value !== "string" || value.trim() === "") {
            return (
              <div
                style={{
                  backgroundColor: "#000",
                  color: "#fff",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                None
              </div>
            );
          }

          let label = value
            .split(/[\s_]+/)
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ");

          return (
            <div
              style={{
                backgroundColor: "#E5E7EB",
                color: "#000",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
            >
              {label}
            </div>
          );
        }

        if (value && typeof value === "string") {
          value = value
            .split(/[\s_]+/)
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ");
        }

        return (
          <div style={{ wordBreak: "break-word", maxWidth: "250px", fontSize: "12px" }}>
            {value}
          </div>
        );
      },
      sortable: true,
      width,
    };
  })];

  // Hide ACTIONS column on these pages
  const hideActionsFor = [
    "/admin/customer-management",
    "/admin/transactions",
    "/admin/contact-us-list",
    "/admin/product-review",

  ];
  // const shouldShowActions = !hideActionsFor.includes(currentPath);
  const shouldShowActions = !hideActionsFor.some(path =>
    currentPath.startsWith(path)
  );


  const onView = (row) => {
    navigate(`/admin/order/${row.id}`);
  };

  //  Add Actions Column Only If Allowed
  if (shouldShowActions) {
    tableColumns.push({
      name: "Actions",
      cell: (row) => (
        <div className="d-flex justify-content-center align-items-center position-relative">

          {[
            "/admin/all-orders",
            "/admin/new-orders",  
            "/admin/delivered-orders",
            "/admin/cancelled-orders",
            "/admin/pending-orders",

          ].includes(currentPath) ? (
            <button
              onClick={() => onView(row)}
              className="btn btn-sm btn-primary"
              title="View"
            >
              <i className="bx bx-show"></i>
            </button>
          ) : (
            <>
              {/* <button
                onClick={() => onEdit(row)}
                className="btn btn-sm btn-primary me-2"
                title="Edit"
              >
                <i className="bx bx-edit"></i>
              </button> */}
              {/* Hide Edit Button on Product Image Gallery Page */}
              {!isProductGalleryPage && (
                <>
                  {onEditLink ? (
                    <a
  href={onEditLink(row)}
  className="btn btn-sm btn-primary me-2"
  title="Edit"
>
  <i className="bx bx-edit"></i>
</a>
                  ) : (
                    <button
                      onClick={() => onEdit(row)}
                      className="btn btn-sm btn-primary me-2"
                      title="Edit"
                    >
                      <i className="bx bx-edit"></i>
                    </button>
                  )}
                </>
              )}



              <button
                onClick={() => onDelete(row.id)}
                className="btn btn-sm btn-danger me-2"
                
                title="Delete"
              >
                <i className="bx bx-trash"></i>
              </button>
            </>
          )}

          {[
            "/admin/all-products",
            "/admin/active-products",
            "/admin/inactive-products",
          ].includes(currentPath) && (
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => handleSettingsClick(row.id)}
                  title="Settings"
                >
                  <i className="bx bx-cog"></i>

                </button>
                {openDropdownId === row.id && (
                  <div className="dropdown-menu show" style={{ top: "-80px", right: "20px", }}>
                    {/* <button
                      className="dropdown-item"
                      onClick={() => handleNavigateToGallery(row.id)}
                    >
                      Image Gallery
                    </button> */}
                    <a
                    href={`/admin/product-image-gallery/${row.id}`}
                    className="dropdown-item"
                  >
                    Image Gallery
                  </a>
                    <button
                      className="dropdown-item"
                      onClick={() => handleNavigateToProductReview(row.id)}
                    >
                      Product Review
                    </button>
                  </div>
                )}
              </div>
            )}
        </div>
      ),
      width: columnWidths.actions,
    });
  }

  const customStyles = {
  headRow: {
    style: {
      fontWeight: "600",
      fontSize: "12px",
      backgroundColor: "#1e939b",
      color: "#fff",
    },
  },

  headCells: {
    style: {
      whiteSpace: "normal",
      wordBreak: "break-word",
      lineHeight: "16px",
      textAlign: "center",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
};

  const hideExportButtonsFor = ["/admin/sliders"];
  const shouldShowExportButtons = !hideExportButtonsFor.includes(currentPath);

  const mobileResponsiveStyles = `
    .crud-toolbar {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
      flex-wrap: wrap;
      box-sizing: border-box;
    }

    .crud-date-input {
      width: 160px !important;
      min-width: 160px !important;
      height: 42px !important;
    }

    .crud-search-input {
      width: 255px !important;
      min-width: 255px !important;
      height: 45px !important;
    }

    .crud-clear-btn {
      height: 42px !important;
      padding: 0 14px !important;
      white-space: nowrap;
    }

    .crud-table-wrapper {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .crud-table-wrapper .rdt_Table {
      min-width: 700px;
    }

    .crud-table-wrapper .rdt_TableCell {
      font-size: 12px;
    }

    .crud-table-wrapper .rdt_TableHeadRow {
      min-height: 48px;
    }

    .crud-table-wrapper .rdt_TableRow {
      min-height: 55px;
    }

    .crud-actions {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      flex-wrap: wrap;
      width: 100%;
    }

    .crud-image {
      width: 70px !important;
      height: 45px !important;
      object-fit: contain;
    }

    @media (max-width: 768px) {

      .crud-toolbar {
        width: 100%;
        justify-content: flex-start;
        align-items: stretch;
        gap: 8px;
        margin-top: 0 !important;
        margin-bottom: 10px !important;
        padding: 0 !important;
      }

      .crud-search-input {
        width: 100% !important;
        min-width: 0 !important;
        height: 42px !important;
        flex: 1 1 100%;
      }

      .crud-date-input {
        width: calc(50% - 4px) !important;
        min-width: 0 !important;
        flex: 1 1 calc(50% - 4px);
      }

      .crud-clear-btn {
        width: 100%;
        height: 40px !important;
      }

      .crud-table-wrapper {
        width: 100%;
        overflow-x: auto;
        margin-top: 0 !important;
      }

      .crud-table-wrapper .rdt_Table {
        min-width: 700px;
      }

      .crud-table-wrapper .rdt_TableCell {
        padding: 8px 10px !important;
        font-size: 11px !important;
      }

      .crud-table-wrapper .rdt_TableHeadRow {
        min-height: 48px !important;
      }

      .crud-table-wrapper .rdt_TableRow {
        min-height: 52px !important;
      }

      .crud-table-wrapper .rdt_TableHead {
        font-size: 11px !important;
      }

      .crud-actions {
        gap: 4px;
        padding: 4px 0;
      }

      .crud-actions .btn {
        margin-right: 0 !important;
        padding: 5px 8px !important;
      }

      .crud-image {
        width: 65px !important;
        height: 42px !important;
      }
    }

    @media (max-width: 480px) {

      .crud-toolbar {
        gap: 7px;
      }

      .crud-date-input {
        height: 40px !important;
        font-size: 12px !important;
      }

      .crud-search-input {
        height: 40px !important;
        font-size: 13px !important;
      }

      .crud-clear-btn {
        height: 38px !important;
        font-size: 12px !important;
      }

      .crud-table-wrapper .rdt_Table {
        min-width: 650px;
      }

      .crud-table-wrapper .rdt_TableCell {
        padding: 7px 8px !important;
        font-size: 10px !important;
      }

      .crud-table-wrapper .rdt_TableHeadRow {
        min-height: 44px !important;
      }

      .crud-table-wrapper .rdt_TableRow {
        min-height: 48px !important;
      }

      .crud-image {
        width: 60px !important;
        height: 40px !important;
      }
    }
  `;

  return (
    <>


    

   {/* SEARCH / FILTER BAR */}
      {/* MOBILE RESPONSIVE STYLES */}
      <style>{mobileResponsiveStyles}</style>

      {/* SEARCH / FILTER BAR */}
      <div
        className="crud-toolbar"
        style={{
          marginTop:
            currentPath.startsWith("/admin/all-products") ||
            currentPath.startsWith("/admin/active-products") ||
            currentPath.startsWith("/admin/inactive-products")
              ? "-0.5rem"
              : "-5rem",

          marginBottom: "0.4rem",
          padding: "0.2rem",
        }}
      >

        {/* DATE FILTERS – ONLY ORDER PAGES */}
        {isOrderPage && (
          <>
            <input
              type="date"
              className="form-control text-dark crud-date-input"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />

            <input
              type="date"
              className="form-control text-dark crud-date-input"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />

            {(startDate || endDate) && (
              <button
                className="btn btn-outline-secondary crud-clear-btn"
                onClick={() => {
                  setStartDate("");
                  setEndDate("");
                }}
              >
                Clear
              </button>
            )}
          </>
        )}

        {/* SEARCH */}
        <input
          type="text"
          placeholder="Search..."
          className="form-control crud-search-input"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>


<div
  style={{
    marginTop:
      currentPath.startsWith("/admin/all-products") ||
      currentPath.startsWith("/admin/active-products") ||
      currentPath.startsWith("/admin/inactive-products")
        ? "0"
        : "-0.3rem",
    padding: "0",
  }}
>
      <DataTable
        columns={tableColumns}
        // data={data}
        data={filteredData}

        pagination
        highlightOnHover
        striped
        responsive
        customStyles={customStyles}
      /> 
      </div>
    </>
  );
}
